// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.NotFoundWrap {
  
  position: relative;
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);
  width: 610px;
  height: 310px;
}

.NotFoundBox  {
  background: #ffffff;
  margin: 5px 5px 5px 5px;
  padding: 20px;
  width: 600px;
  height: 300px;
  
}`, "",{"version":3,"sources":["webpack://./src/app/layout/NotFound/NotFound.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,aAAa;;AAEf","sourcesContent":[".NotFound {\n  min-height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.NotFoundWrap {\n  \n  position: relative;\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n  width: 610px;\n  height: 310px;\n}\n\n.NotFoundBox  {\n  background: #ffffff;\n  margin: 5px 5px 5px 5px;\n  padding: 20px;\n  width: 600px;\n  height: 300px;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
